import React, { useEffect, useRef } from "react";
import { getDateString } from "../../../constant/helper";
import AvatarPreview from "../../profile/components/AvatarPreview";
import classes from "./ChatHeaderLogo.module.scss";

const ChatHeaderLogo = ({ info, show, close }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        close();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [close]);

  return (
    <>
      {show && (
        <div className={classes.body} ref={wrapperRef}>
          <div className={classes["items"]}>
            <div className={classes["avatar-wrapper"]}>
              <AvatarPreview
                style={classes.avatar}
                src={info?.lawyer?.extraInfo?.avatarImageUrl}
              />
              <div className={classes["leaf"]} />
              <div className={classes["name"]}>
                <h2>
                  {info?.lawyer?.extraInfo?.firstName}
                  {info?.lawyer?.extraInfo?.lastName}
                </h2>
              </div>
              <div className={classes["info"]}>
                <div className={classes["info-item"]}>
                  شماره پروانه : {info?.professionalProfile?.licenceNumber}
                </div>
                <div className={classes["info-item"]}>
                  تاریخ صدور :{" "}
                  {getDateString(+info?.professionalProfile?.licenceIssuedAt)}
                </div>
                <div className={classes["info-item"]}>
                  تخصص : {info?.rootCategoryName}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatHeaderLogo;
